import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';

@Component({
    selector: 'tt-po-job-labours',
    templateUrl: './po-job-labours.component.html',
    styleUrls: ['./po-job-labours.component.css'],
    standalone: false
})
export class PoJobLaboursComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(2597, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_pojoblabours_grid')
                .setLoadDataFunction({
                    method: 2598,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    prod_id: string;
    prod_name: string;
    prod_id_and_name: string;
    argtype: string;
    argvalue: string;
    po_keyno: string;
    postatus_name: string;
    powork_keyno: string;
    workgrp_name: string;
    equipment_name: string;
    operation_name: string;
    pojob_keyno: string;
    start_dt: string;
    end_dt: string;
}
